import axios from 'axios';
import {BaseResponse} from "../BaseResponse";
import {VihecleRequest} from "./postVihecle";

export async function updateVihecle(vihecleId : string, request: VihecleRequest) {
    const response = await axios.put<BaseResponse<boolean>>(`/vihecle/${vihecleId}`, request)

    return response.data
}